import keyMirror from 'keymirror';

export const FaqActionTypes = keyMirror({
  SHOW_FAQ_WINDOW: undefined,
  HIDE_FAQ_WINDOW: undefined,
  RESET_FAQ_WINDOW: undefined,
  POPULATE_FAQ_DATA:undefined,
});
